import React from "react";
import { Textfit } from "react-textfit";

import s from "./NamePlate.module.scss";
import AiTitle from "./AiTitle";

import namePlateBg from "../../../assets/images/name_plate_bg.png";
import namePlateTitleBg from "../../../assets/images/name_plate_title_bg.png";

import namePlateTagP1 from "../../../assets/images/name_plate_tag_p1.png";
import namePlateTagP2 from "../../../assets/images/name_plate_tag_p2.png";
import namePlateTextP1 from "../../../assets/images/name_plate_text_p1.png";
import namePlateTextP2 from "../../../assets/images/name_plate_text_p2.png";

import namePlateTitleP1 from "../../../assets/images/name_plate_title_p1.png";
import namePlateTitleP2 from "../../../assets/images/name_plate_title_p2.png";
import namePlateTitleWood from "../../../assets/images/name_plate_title_wood.png";
import namePlateTitleRainbow from "../../../assets/images/name_plate_title_rainbow.png";
import namePlateTitlePurple from "../../../assets/images/name_plate_title_purple.png";
import namePlateTitleGold from "../../../assets/images/name_plate_title_gold.png";

const NamePlate = ({ name, title, player, shougouBaseId }) => {
    const getPlayerTag = () => {
        switch (player) {
            case 1:
                return namePlateTagP1;
            case 2:
                return namePlateTagP2;
            default:
                return null;
        }
    };

    const getPlayerText = () => {
        switch (player) {
            case 1:
                return namePlateTextP1;
            case 2:
                return namePlateTextP2;
            default:
                return null;
        }
    };

    const getshougouBase = () => {
        switch (shougouBaseId) {
            case 0:
                return <img src={namePlateTitleWood} alt="shougouBase" />;
            case 1:
                return <img src={namePlateTitleRainbow} alt="shougouBase" />;
            case 2:
                return <img src={namePlateTitleGold} alt="shougouBase" />;
            case 3:
                return <img src={namePlateTitlePurple} alt="shougouBase" />;
            case 4:
                return <AiTitle id={shougouBaseId} />;
            case 5:
                return <AiTitle id={shougouBaseId} />;
            case 6:
                return <AiTitle id={shougouBaseId} />;
            case 7:
                return <AiTitle id={shougouBaseId} />;
            default:
                return player === 1 ? (
                    <img src={namePlateTitleP1} alt="shougouBase" />
                ) : (
                    <img src={namePlateTitleP2} alt="shougouBase" />
                );
        }
    };

    return (
        <div className={s.namePlate}>
            <div className={s.bg}>
                <img src={namePlateBg} alt="name plate background" />
            </div>
            <div className={s.titleBg}>
                <img src={namePlateTitleBg} alt="name plate title background" />
            </div>
            {player ? (
                <>
                    <div className={s.playerTag}>
                        <img src={getPlayerTag()} alt="name plate player tag" />
                    </div>
                    <div className={s.playerText}>
                        <img
                            src={getPlayerText()}
                            alt="name plate player text"
                        />
                    </div>
                </>
            ) : null}
            <div className={s.title}>
                {getshougouBase()}
                <Textfit
                    mode="single"
                    max={18}
                    forceSingleModeWidth={false}
                    className={s.titleText}
                >
                    {title}
                </Textfit>
            </div>

            <div className={s.name}>
                <Textfit
                    mode="single"
                    forceSingleModeWidth={false}
                    max={22}
                    className={s.nameText}
                >
                    {name}
                </Textfit>
                <Textfit
                    mode="single"
                    forceSingleModeWidth={false}
                    max={22}
                    className={s.nameTextOutline}
                >
                    {name}
                </Textfit>
            </div>
        </div>
    );
};

export default NamePlate;
